import { render, staticRenderFns } from "./PrestacoesDescontadas.vue?vue&type=template&id=9e3edb06&scoped=true&"
import script from "./PrestacoesDescontadas.vue?vue&type=script&lang=js&"
export * from "./PrestacoesDescontadas.vue?vue&type=script&lang=js&"
import style0 from "./PrestacoesDescontadas.vue?vue&type=style&index=0&id=9e3edb06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e3edb06",
  null
  
)

export default component.exports